import React from "react";
import { FaBagShopping } from "react-icons/fa6";
import { MdCurrencyRupee } from "react-icons/md";
import { HiBanknotes } from "react-icons/hi2";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { Tooltip } from "react-tooltip";
import "./MerchantOverview.css";

const FirstSection = ({ payInStatistic, payoutStatistic }) => {
  const payInData = payInStatistic?.payIn || {};
  const payoutData = payoutStatistic?.payout || {};

  const payoutNet =
    payoutData.payoutSettlementAmount && payoutData.payoutOutProcessing
      ? (
          payoutData.payoutSettlementAmount - payoutData.payoutOutProcessing
        ).toFixed(2)
      : "0";

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <div>
          <h3>Transactions</h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gridTemplateRows: "repeat(2, auto)",
              gap: "1rem",
            }}
          >
            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Total Payin Volume</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element1"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element1"
                  place="top"
                  className="custom-reduce"
                >
                  Total Number Of Payin Transactions
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">{payInData.payInTotal || "0"}</p>
                <div className="icon-div">
                  <FaBagShopping
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>

            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Total Deposits</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element"
                  place="top"
                  className="custom-reduce"
                >
                  Total Payin Amount Without Commission And Rolling Reserve
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  ₹ {Number(payInData?.payinAmount).toFixed(2) || "0.00"}
                </p>
                <div className="icon-div">
                  <MdCurrencyRupee
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>

            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Net Payin Amount</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element2"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element2"
                  place="top"
                  className="custom-reduce"
                >
                  Payin After Commission and Rolling Reserve is Deducted
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  ₹ {payInData.payinSettlementAmount?.toFixed(2) || "0.00"}
                </p>
                <div className="icon-div">
                  <HiBanknotes
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>

            <div className="new-section-1" style={{ gridRow: "span 2" }}>
              <div className="comm-side">
                <p className="heading-new">Total Commission</p>
                <p className="sub-heading-new">
                  ₹{" "}
                  {(
                    Number(payInData.payinTotalComission || 0) +
                    (payoutData.payoutTotalComission || 0)
                  ).toFixed(2)}
                </p>
              </div>

              <div className="comm-side">
                <p className="heading-new">Commission For Payin</p>
                <p className="sub-heading-new">
                  ₹ {Number(payInData.payinTotalComission || "0").toFixed(2)}
                </p>
              </div>

              <div className="comm-side">
                <p className="heading-new">Commission For Payout</p>
                <p className="sub-heading-new">
                  ₹ {Number(payoutData?.payoutTotalComission || "0").toFixed(2)}
                </p>
              </div>
            </div>

            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Total Payout Volume</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element4"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element4"
                  place="top"
                  className="custom-reduce"
                >
                  Total Number Of Payout Transactions
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  {payoutData?.payOutTotal || "0"}
                </p>
                <div className="icon-div">
                  <FaBagShopping
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>

            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Total Withdrawal</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element"
                  place="top"
                  className="custom-reduce"
                >
                  Total Payout Amount Without Commission
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  {/* ₹ {payInStatistic?.payinAmount ? payInStatistic.payinAmount.toFixed(2) : "0"} */}
                  ₹ {Number(payoutData?.payoutAmount).toFixed(2) || "0.00"}
                </p>
                <div className="icon-div">
                  <MdCurrencyRupee
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>

            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Net Payout Amount</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element6"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element6"
                  place="top"
                  className="custom-reduce"
                >
                  Payout with Commission Added
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  ₹{" "}
                  {Number(payoutData?.payoutSettlementAmount).toFixed(2) ||
                    "0.00"}
                </p>
                <div className="icon-div">
                  <HiBanknotes
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>
            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Total Payout Initiated</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element9"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element9"
                  place="top"
                  className="custom-reduce"
                >
                  Total payout in processing
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  {" "}
                  ₹ {Number(payoutData?.payoutOutProcessing || 0).toFixed(2)}
                </p>
                <div className="icon-div">
                  <HiBanknotes
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gridTemplateRows: "repeat(2, auto)",
            gap: "1rem",
          }}
        >
          <div>
            <h3>Success Rate(s)</h3>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gridTemplateRows: "repeat(2, auto)",
                gap: "1rem",
              }}
            >
              <div className="new-section">
                <div className="data-icon-box">
                  <p className="heading-new">Payin Success Rate</p>
                  <IoMdInformationCircleOutline
                    className="my-anchor-element11"
                    style={{ color: "#878a99" }}
                  />
                  <Tooltip
                    anchorSelect=".my-anchor-element11"
                    place="top"
                    className="custom-reduce"
                  >
                    Percentage of successful payin transactions.
                  </Tooltip>
                </div>
                <div className="data-icon-box">
                  <p className="sub-heading-new">
                    {" "}
                    {Number(payInData?.payinSuccessRate || 0).toFixed(2)}%
                  </p>
                  <div className="icon-div">
                    <HiBanknotes
                      style={{ width: "1rem", height: "1rem", color: "white" }}
                    />
                  </div>
                </div>
              </div>
              <div className="new-section">
                <div className="data-icon-box">
                  <p className="heading-new">Payout Success Rate</p>
                  <IoMdInformationCircleOutline
                    className="my-anchor-element12"
                    style={{ color: "#878a99" }}
                  />
                  <Tooltip
                    anchorSelect=".my-anchor-element12"
                    place="top"
                    className="custom-reduce"
                  >
                    Percentage of successful payout transactions.
                  </Tooltip>
                </div>
                <div className="data-icon-box">
                  <p className="sub-heading-new">
                    {" "}
                    {Number(payoutData?.payoutSuccessRate || 0).toFixed(2)}%
                  </p>
                  <div className="icon-div">
                    <HiBanknotes
                      style={{ width: "1rem", height: "1rem", color: "white" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h3>Balance</h3>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gridTemplateRows: "repeat(2, auto)",
                gap: "1rem",
              }}
            >
              <div className="new-section">
                <div className="data-icon-box">
                  <p className="heading-new">Wallet Balance</p>
                  <IoMdInformationCircleOutline
                    className="my-anchor-element18"
                    style={{ color: "#878a99" }}
                  />
                  <Tooltip
                    anchorSelect=".my-anchor-element18"
                    place="top"
                    className="custom-reduce"
                  >
                    Total wallet balance.
                  </Tooltip>
                </div>
                <div className="data-icon-box">
                  <p className="sub-heading-new">
                    {" "}
                    ₹{" "}
                    {Number(
                      payInData?.walletBalance || 0
                    ).toFixed(2)}
                  </p>
                  <div className="icon-div">
                    <HiBanknotes
                      style={{ width: "1rem", height: "1rem", color: "white" }}
                    />
                  </div>
                </div>
              </div>
              <div className="new-section">
                <div className="data-icon-box">
                  <p className="heading-new">Available Balance</p>
                  <IoMdInformationCircleOutline
                    className="my-anchor-element19"
                    style={{ color: "#878a99" }}
                  />
                  <Tooltip
                    anchorSelect=".my-anchor-element19"
                    place="top"
                    className="custom-reduce"
                  >
                    Total available balance.
                  </Tooltip>
                </div>
                <div className="data-icon-box">
                  <p className="sub-heading-new">
                    {" "}
                    ₹{" "}
                    {Number(
                      payInData?.availableBalance || 0
                    ).toFixed(2)}
                  </p>
                  <div className="icon-div">
                    <HiBanknotes
                      style={{ width: "1rem", height: "1rem", color: "white" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <h3>Rolling Reserve & Chargeback</h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gridTemplateRows: "repeat(2, auto)",
              gap: "1rem",
            }}
          >
            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Total Rolling Reserve</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element7"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element7"
                  place="top"
                  className="custom-reduce"
                >
                  Total Rolling Reserve
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  {" "}
                  ₹ {Number(payInData.payinRollingReserve || 0).toFixed(2)}
                </p>
                <div className="icon-div">
                  <HiBanknotes
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>
            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Total Chargeback</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element8"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element8"
                  place="top"
                  className="custom-reduce"
                >
                  Total Chargeback
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  {" "}
                  ₹ {Number(payInData.payinChargeBack || 0).toFixed(2)}
                </p>
                <div className="icon-div">
                  <HiBanknotes
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>

            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Total Penalty</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element10"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element10"
                  place="top"
                  className="custom-reduce"
                >
                  Total payin penalty
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  {" "}
                  ₹ {Number(payInData?.payinPenalty || 0).toFixed(2)}
                </p>
                <div className="icon-div">
                  <HiBanknotes
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h3>Settlement Amount</h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)",
              gridTemplateRows: "repeat(2, auto)",
              gap: "1rem",
            }}
          >
            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Net Amount 12AM-5AM(INR)</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element13"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element13"
                  place="top"
                  className="custom-reduce"
                >
                  Total Payin between 12AM to 5AM.
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  {" "}
                  ₹{" "}
                  {Number(
                    payInData?.payinTimeBreakdown?.time_12am_5am || 0
                  ).toFixed(2)}
                </p>
                <div className="icon-div">
                  <HiBanknotes
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>
            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Net Amount 5AM-7AM(INR)</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element14"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element14"
                  place="top"
                  className="custom-reduce"
                >
                  Total Payin between 5AM to 7AM.
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  {" "}
                  ₹{" "}
                  {Number(
                    payInData?.payinTimeBreakdown?.time_5am_7am || 0
                  ).toFixed(2)}
                </p>
                <div className="icon-div">
                  <HiBanknotes
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>
            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Net Amount 7AM-1PM(INR)</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element15"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element15"
                  place="top"
                  className="custom-reduce"
                >
                  Total Payin between 7AM to 1PM.
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  {" "}
                  ₹{" "}
                  {Number(
                    payInData?.payinTimeBreakdown?.time_7am_1pm || 0
                  ).toFixed(2)}
                </p>
                <div className="icon-div">
                  <HiBanknotes
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>
            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Net Amount 1PM-7PM(INR)</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element16"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element16"
                  place="top"
                  className="custom-reduce"
                >
                  Total Payin between 1PM to 7PM.
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  {" "}
                  ₹{" "}
                  {Number(
                    payInData?.payinTimeBreakdown?.time_1pm_7pm || 0
                  ).toFixed(2)}
                </p>
                <div className="icon-div">
                  <HiBanknotes
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>
            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Net Amount 7PM-12AM(INR)</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element17"
                  style={{ color: "#878a99" }}
                />
                <Tooltip
                  anchorSelect=".my-anchor-element17"
                  place="top"
                  className="custom-reduce"
                >
                  Total Payin between 7PM to 12AM
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  {" "}
                  ₹{" "}
                  {Number(
                    payInData?.payinTimeBreakdown?.time_7am_12am || 0
                  ).toFixed(2)}
                </p>
                <div className="icon-div">
                  <HiBanknotes
                    style={{ width: "1rem", height: "1rem", color: "white" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FirstSection;
